import { ListeTable } from '@mairistem/liste';

import type { ModeReglementType } from '@/types';

interface ModesReglementListeTableRowProps {
  item: ModeReglementType;
  rowProps: Record<string, unknown>;
}

const ModesReglementListeTableRow = (props: ModesReglementListeTableRowProps) => {
  const { item, rowProps } = props;

  const { identifiant, libelle, code, actif } = item;

  if (!actif) {
    return (
      <ListeTable.Row key={identifiant} {...rowProps} disabled>
        <ListeTable.Cell name="libelle">
          <i>{libelle}</i>
        </ListeTable.Cell>
        <ListeTable.Cell name="code">
          <i>{code}</i>
        </ListeTable.Cell>
      </ListeTable.Row>
    );
  }

  return (
    <ListeTable.Row key={identifiant} {...rowProps} disabled={!actif}>
      <ListeTable.Cell name="libelle">{libelle}</ListeTable.Cell>
      <ListeTable.Cell name="code">{code}</ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default ModesReglementListeTableRow;
